// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import { Props } from './types';
import { fontSize, spacing } from 'presentations/views/styles';

export default function Confirm(props: Props) {
  const t = translateInComponent(translations);

  return (
    <div>
      <StyledText>
        {t('Downgrade? text', {
          planName: props.planName,
          endedAt: props.endedAt,
        })}
      </StyledText>
    </div>
  );
}

const StyledText = styled.div`
  text-align: left;
  margin-bottom: ${spacing(40)};
  white-space: pre-wrap;
  font-size: ${fontSize(14)};
`;
